var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-wrapper"}},[_c('menu-nav',{staticClass:"app-sidebar",style:(_vm.isShowSecondMenu ? 'width:200px;':'width:90px;')}),_vm._v(" "),_c('app-container',{style:(_vm.isShowSecondMenu ? 'margin-left:200px;':'margin-left:90px;')})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e85def","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = null
// module chunks = 